enum FetchingStatus {
  InProgress = 'inProgress',
  Succeeded = 'succeeded',
  Failed = 'failed',
}

export default FetchingStatus;
